export const SEARCH_PLACEHOLDER = 'Search previous customers';
